import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTreyarchComponent } from './simple-icons-treyarch.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTreyarchComponent ],
    exports:      [ SimpleIconsTreyarchComponent ],
    bootstrap:    []
})
export class SimpleIconsTreyarchModule {}
